import { render } from "./technischerSupport.vue?vue&type=template&id=6461a384"
import script from "./technischerSupport.vue?vue&type=script&lang=js"
export * from "./technischerSupport.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tommygrimm/PhpstormProjects/holcimportal.20north.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__